module.exports = __webpack_public_path__ + "img/CS-Lite_Overview-Middle_1.e515574f.jpg";